/* eslint-disable @typescript-eslint/require-await */
import type { AuthFeature, AuthResult, AuthStrategy } from "./types";

export abstract class BaseAuthStrategy implements AuthStrategy {
	abstract readonly type: string;
	abstract readonly name: string;
	readonly description?: string;

	abstract authenticate(credentials: unknown): Promise<AuthResult>;

	async logout(): Promise<void> {
		// Default implementation - can be overridden
	}

	async refresh(): Promise<AuthResult> {
		// Default implementation - can be overridden
		return { success: false, error: "Refresh not supported" };
	}

	async validate(): Promise<boolean> {
		// Default implementation - can be overridden
		return true;
	}

	isAvailable(): boolean {
		// Default implementation - can be overridden
		return true;
	}

	getRequiredFields(): string[] {
		// Default implementation - can be overridden
		return [];
	}

	supportsFeature(_feature: AuthFeature): boolean {
		// Default implementation - can be overridden
		return false;
	}

	protected handleError(error: unknown): AuthResult {
		const message =
			error instanceof Error ? error.message : "Unknown error occurred";
		return {
			success: false,
			error: message,
			details: error instanceof Error ? { stack: error.stack } : undefined,
		};
	}
}
